import Vue from "vue";

import AmountsWithTransferSummary from './Components/amountsWithTransferSummary.vue';
import TopupWithPrices from './Components/topupWithPrices.vue';
import HtmlElementHelper from "../../../../Shared/Helpers/htmlElementHelper";

export class TopicHelper {
    public static updateTopics(id: string, storeId: string) {
        let verificationToken = document.getElementsByName("__RequestVerificationToken")[0] as HTMLInputElement;

        const formData = new URLSearchParams();
        formData.append('url', location.origin + location.pathname);
        formData.append('id', id);
        formData.append('storeId', storeId);
        formData.append('__RequestVerificationToken', verificationToken.value);

        fetch("/fmtopics/updatehtml", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: formData
        }).then(response => {
                HtmlElementHelper.Hide('#successMessage');
                HtmlElementHelper.Hide('#errorMessage');
                HtmlElementHelper.Show(response.ok ? '#successMessage' : '#errorMessage');
            });
    }
}

(<any>window).TopicHelper = TopicHelper;

Vue.mixin({
    created: function() {
        (<any>window).FmGlobals.translations = new Array<string>;
    },
    methods: {
        t: function (value: string) {
            const tr = (<any>window).FmGlobals.translations;
            if (tr.hasOwnProperty(value))
                return tr[value];

            return value;
        },
        async fetchTranslations(fetchTranslationsUrl: string) {
            const translationKeys = new Array<String>();

            const elements = document.getElementsByClassName("vue-translations");
            for (let element of elements) {
                element.querySelectorAll('[data-t]').forEach(x => {
                    translationKeys.push(x.getAttribute("data-t"));
                });
            }

            return await fetch(fetchTranslationsUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(
                    translationKeys
                )
            })
                .then(response => {
                    return response.json();
                })
                .then(response => {
                    (<any>window).FmGlobals.translations = response;
                    return true;
                })
                .catch(() => {
                    return false;
                });
        }
    },
})

export const fmComponentsContainer = new Vue({
    data: {
        Urls: {
            FetchTranslationsUrl: "/vue/components/translations/fetch"
        }
    },
    mounted() {
        this.fetchInitialData();
    },
    components: {
        "AmountsWithTransferSummary": AmountsWithTransferSummary,
        "TopupWithPrices": TopupWithPrices
    },
    methods: {
        fetchInitialData: async function () {
            const translationsReady = await this.fetchTranslations(this.Urls.FetchTranslationsUrl);
            if (translationsReady)
                this.$emit("translationsFetched");
        },
    }
});

if (document.getElementById("vue-components-container")) {
    fmComponentsContainer.$mount('#vue-components-container');
}

